import React from 'react';
import { observer } from 'mobx-react';
import { Button } from '@this/src/components/shared/ui/inputs/button';
import { TableCell, TableRow } from '@this/src/components/shared/ui/data_displays/table';
import type HotelOrderItemEanTotal from '@this/src/domain/arrangement/hotel_order_item_ean_total';

interface Props {
  hotelOrderItemEanTotal: HotelOrderItemEanTotal;
}

const TotalTableRow: React.FC<Props> = observer(({ hotelOrderItemEanTotal }) => {
  const reservationDate = hotelOrderItemEanTotal.reservationDate.format('YYYY-MM-DD');

  const hotelElementCsvParams = new URLSearchParams([['reservation_date', reservationDate]]);
  const hotelElementCsvUrl = `/arrangement/auto_reservation_inventory/ean_hotel/total/hotel_element_csv?${hotelElementCsvParams}`;

  const eanCsvParams = new URLSearchParams([['reservation_date', reservationDate]]);
  const eanCsvUrl = `/arrangement/auto_reservation_inventory/ean_hotel/total/ean_csv?${eanCsvParams}`;

  return (
    <TableRow>
      <TableCell>{reservationDate}</TableCell>
      <TableCell align="right">{hotelOrderItemEanTotal.hotelElementTotal?.toLocaleString() || 0}</TableCell>
      <TableCell align="right">
        {hotelOrderItemEanTotal.orderItemOriginalPriceTotal?.toLocaleString() || 0}
      </TableCell>
      <TableCell align="right">{hotelOrderItemEanTotal.eanRecordTotal?.toLocaleString() || 0}</TableCell>
      <TableCell align="right">
        {hotelOrderItemEanTotal.orderItemPriceDetailsPriceTotal?.toLocaleString() || 0}
      </TableCell>
      <TableCell align="right">
        {hotelOrderItemEanTotal.orderItemOriginalPricePriceTotal?.toLocaleString() || 0}
      </TableCell>
      <TableCell align="right">{hotelOrderItemEanTotal.eanRecordPriceTotal?.toLocaleString() || 0}</TableCell>
      <TableCell>{hotelOrderItemEanTotal.exactMatch ? '○' : '×'}</TableCell>
      <TableCell>
        <Button href={hotelElementCsvUrl} isExternal>
          Hotel Element CSV
        </Button>
      </TableCell>
      <TableCell>
        <Button href={eanCsvUrl} isExternal>
          EAN CSV
        </Button>
      </TableCell>
      <TableCell>{hotelOrderItemEanTotal.confirmedAt?.format('YYYY-MM-DD') || '─'}</TableCell>
      <TableCell>{hotelOrderItemEanTotal.confirmerNames || '─'}</TableCell>
    </TableRow>
  );
});

export default TotalTableRow;
